import React from "react";
import "../App.css"; // Main CSS file for styling

function TermsAndConditions() {
  return (
    <div className="terms-page">
      <h1>Terms and Conditions</h1>
      
      <h2>Appointment Notification/Cancel Appointment Disclaimer</h2>
      <p>
        The information provided by this application and its intended purpose are 
        provided, in the best of its ability, to notify of delays in scheduled 
        appointments. At any given time during use, delays present or absent, 
        Timely Innovation Group, LLC is not responsible for inaccurate information 
        related to improper data entry or dysfunctional operating systems resulting 
        in inaccurate alerts or delays. Additionally, potential delays in 
        appointment times do not constitute a given user's right to 
        reschedule or cancel said appointment, without risk of penalty, 
        financial or otherwise, in accordance with the rules and regulations 
        set forth by the individual health systems, providers, and/or office.
      </p>

      <h2>General Disclaimer</h2>
      <p>
        The information provided by this application is for general informational 
        purposes only. While we strive to ensure that the content is accurate and 
        up-to-date, we make no guarantees regarding its completeness, accuracy, 
        reliability, or suitability for your specific needs. The use of this application is
        at your own risk, and we disclaim all liability for any loss or damage 
        incurred as a result of relying on the information provided.
      </p>

      <h2>Privacy Disclaimer</h2>
      <p>
        We are committed to protecting your privacy. Any personal information you 
        provide while using this application will be handled in accordance with our 
        Privacy Policy. However, no method of data transmission or storage is 100% 
        secure. By using this application, you acknowledge and accept the inherent 
        risks associated with transmitting data over the internet.
      </p>

      <h2>Product Disclaimer</h2>
      <p>
        This application is not a substitute for professional medical advice, 
        diagnosis, or treatment. Always seek the advice of your physician or another
        qualified healthcare provider with any questions you may have regarding a 
        medical condition. Do not disregard professional medical advice or delay 
        seeking it because of information provided by this application. If you are 
        experiencing a medical emergency, call your local emergency services 
        immediately.
      </p>

      <h2>Medical Advice Disclaimer</h2>
      <p>
        The content provided in this application is not intended to constitute 
        medical advice or replace a consultation with a qualified healthcare 
        professional. Any health-related decisions should be made in consultation 
        with your healthcare provider, and you should not rely solely on the 
        information provided in this application. Always verify information with a 
        medical professional before making any decisions regarding your health or 
        treatment.
      </p>

      <h2>Copyright Disclaimer</h2>
      <p>
        All content within this application, including but not limited to text, 
        graphics, images, and software, is the property of Timely Innovation Group, LLC 
        and is protected by copyright and other intellectual property laws. 
        Unauthorized reproduction, distribution, or use of this content is strictly 
        prohibited.
      </p>

      <h2>Changes to the Disclaimer</h2>
      <p>
        We reserve the right to modify this disclaimer at any time without prior 
        notice. Continued use of the application after any changes constitutes your 
        acceptance of the updated disclaimer.
      </p>

      <p>
        For more information, please refer to our <a href="/terms">Terms of Service</a> and <a href="/terms">Privacy Policy</a>.
      </p>
    </div>
  );
}

export default TermsAndConditions;